import type { ComponentProps, ElementType } from 'react'
import { classNames } from '~/utils/client/helpers'
import type { WidthOption } from '~/utils/client/ui/grid'
import { gridWidth } from '~/utils/client/ui/grid'

type PolymorphicAsProp<E extends ElementType> = {
  as?: E
}

export type GridCellProps<E extends ElementType> = {
  widthDesktop?: WidthOption
  widthTablet?: WidthOption
  children?: React.ReactNode
  rounded?: boolean
  as?: E
} & Omit<ComponentProps<E>, 'as'> &
  PolymorphicAsProp<E>

export const GridCell = <As extends ElementType = 'div'>({
  as,
  children,
  defaultWidth = 'full',
  widthDesktop = 'full',
  widthTablet = 'full',
  rounded = true,
  className,
  ...props
}: GridCellProps<As>) => {
  const Element = as || 'div'
  const widthClass = gridWidth(
    widthDesktop !== 'full' ? widthDesktop : widthTablet !== 'full' ? widthTablet : defaultWidth
  )
  const dynamicClass = classNames(rounded ? 'rounded-lg ' : '')
  return (
    <Element className={classNames(widthClass, dynamicClass, className)} {...props}>
      {children}
    </Element>
  )
}
